import React, { createContext, useState } from 'react'
import {
  Background,
  ModalWrapper,
  Button,
  HeaderModalClose,
  ContentWrapper
} from './modal-style'
import IconClose from '../assets/icons/icon-close.svg'

interface ModalProps {
  title: string
  description: string
  type?: 'normal' | 'message' | 'steps'
  confirmText?: string
  onClickConfirm?: () => void
  autoHide?: boolean
}

interface ContextProps {
  showModal: (modalProps: ModalProps) => void
  hideModal: () => void
}

const defaultValue: ContextProps = {
  showModal: () => {
    throw new Error('showModal must be defined')
  },

  hideModal: () => {
    throw new Error('hideModal must be defined')
  }
}

export const ModalContext = createContext(defaultValue)

export const ModalProvider: React.FC = ({ children }) => {
  const defaultModalProps: ModalProps = {
    title: 'Title',
    description: 'Your description here',
    confirmText: 'Ok',
    onClickConfirm: () => null,
    autoHide: false
  }

  const [show, setShow] = useState(false)
  const [modalProps, setModalProps] = useState<ModalProps>(defaultModalProps)
  const { title, description, confirmText, onClickConfirm, autoHide, type } =
    modalProps

  const onClickConfirmHandler = () => {
    if (autoHide) {
      setShow(false)
    }

    onClickConfirm!()
  }

  const modalContextProps: ContextProps = {
    showModal: (props) => {
      setModalProps({ ...modalProps, ...props })
      setShow(true)
    },
    hideModal: () => setShow(false)
  }

  return (
    <ModalContext.Provider value={modalContextProps}>
      {show && (
        <Background>
          <ContentWrapper>
            <HeaderModalClose
              className="header-modal-close"
              aria-label="Close modal"
              onClick={() => {
                setShow((prev) => !prev)
              }}
            >
              <img src={IconClose} alt="Fechar modal" />
            </HeaderModalClose>
            <ModalWrapper>
              <div className="title">
                <h2 className="modal-title">{title}</h2>
              </div>
              <p className="modal-description">{description}</p>
              {type === 'message' ? (
                <Button
                  onClick={() => {
                    setShow((prev) => !prev)
                  }}
                >
                  {confirmText}
                </Button>
              ) : (
                <div className="button-container">
                  <Button
                    onClick={() => {
                      setShow((prev) => !prev)
                    }}
                  >
                    {confirmText}
                  </Button>
                  <Button
                    className="button-outline"
                    onClick={() => {
                      setShow((prev) => !prev)
                    }}
                  >
                    Cancelar
                  </Button>
                </div>
              )}
            </ModalWrapper>
          </ContentWrapper>
        </Background>
      )}
      {children}
    </ModalContext.Provider>
  )
}
